module.exports = __webpack_public_path__ + "static/media/loader.271ee68c.svg";